var map = {
	"./adult/nn/5 1 Leseforstaelse Intro.mp3": 804,
	"./adult/no/5 1 Leseforstaelse Intro.mp3": 805,
	"./adult/se/5 1 Leseforstaelse Intro.mp3": 806,
	"./youth/de/5 1 Leseforstaelse Intro.mp3": 807,
	"./youth/nn/5 1 Leseforstaelse Intro.mp3": 808,
	"./youth/no/5 1 Leseforstaelse Intro.mp3": 809,
	"./youth/se/5 1 Leseforstaelse Intro.mp3": 810
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 803;